export default __webpack_public_path__ + "static/media/10.f326aca2.svg";